<template>
  <div>
    <a-skeleton :loading="spinning" active>
      <a-table :columns="columns" :pagination="pagination" :data-source="records" size="middle" row-key="id" @change="handleTableChange">
        <template slot="number" slot-scope="record">{{ record.index }}</template>
        <template slot="operator" slot-scope="operator">{{ operator ? operator.nickname : '系统' }}</template>
        <template slot="diffItem" slot-scope="record">
          <div v-for="(item, key) in record.value_diff" :key="key">{{ item.label }}</div>
        </template>
        <template slot="before" slot-scope="record">
          <span v-for="(item, key) in record.value_diff" :key="key">
            <div v-if="['Title', 'StartTime', 'EndTime'].includes(item.value)">{{ item.before ? item.before : '--' }}</div>
            <div v-else-if="item.value === 'ValueIsReach'">{{ item.before ? '是' : '否' }}</div>
            <div v-else-if="item.value === 'Type'">{{ item.before && retrospectType[item.before] ? retrospectType[item.before].label : '--' }}</div>
            <div v-else-if="['ConclusionDoc', 'AfterPlanDoc', 'RetrospectDoc'].includes(item.value)">
              <a v-if="item.after !== null" @click="onPreview(item.before, `「变更前」${item.label}`)">查看详情</a>
              <span v-else>--</span>
            </div>
            <div v-else-if="item.value === 'Files'">
              <span v-if="item.before && item.before.length > 0">
                <UploadFile :key="key" :is-edit="false" :data-list.sync="item.before" />
              </span>
              <div v-else>--</div>
            </div>
            <div v-else-if="item.value === 'Images'">
              <span v-if="item.before && item.before.length > 0">
                <UploadImg :key="key" :is-edit="false" :data-list.sync="item.before" />
              </span>
              <div v-else>--</div>
            </div>
            <div v-else>--</div>
          </span>
        </template>
        <template slot="after" slot-scope="record">
          <span v-for="(item, key) in record.value_diff" :key="key">
            <div v-if="['Title', 'StartTime', 'EndTime'].includes(item.value)">{{ item.after ? item.after : '--' }}</div>
            <div v-else-if="item.value === 'ValueIsReach'">{{ item.after ? '是' : '否' }}</div>
            <div v-else-if="item.value === 'Type'">{{ item.after && retrospectType[item.after] ? retrospectType[item.after].label : '--' }}</div>
            <div v-else-if="['ConclusionDoc', 'AfterPlanDoc', 'RetrospectDoc'].includes(item.value)">
              <a v-if="item.after !== null" @click="onPreview(item.after, `「变更后」${item.label}`)">查看详情</a>
              <span v-else>--</span>
            </div>
            <div v-else-if="item.value === 'Files'">
              <span v-if="item.after && item.after.length > 0">
                <UploadFile :key="key" :is-edit="false" :data-list.sync="item.after" />
              </span>
              <div v-else>--</div>
            </div>
            <div v-else-if="item.value === 'Images'">
              <span v-if="item.after && item.after.length > 0">
                <UploadImg :key="key" :is-edit="false" :data-list.sync="item.after" />
              </span>
              <div v-else>--</div>
            </div>
            <div v-else>--</div>
          </span>
        </template>
      </a-table>
    </a-skeleton>
    <preview-modal ref="previewModal" />
  </div>
</template>

<script>
import { userList } from '@/api/system/auth';
import { retrospectType } from '@/utils/dictionary';
import { queryRecords } from '@/api/business/requirement';

import PreviewModal from '@/pages/project/components/PreviewModal';
import UploadImg from '@/pages/business/requirement/components/UploadImg';
import UploadFile from '@/pages/business/requirement/components/UploadFile';

const columns = [
  {
    title: '序号',
    width: '5%',
    align: 'center',
    scopedSlots: { customRender: 'number' }
  },
  {
    title: '操作人',
    width: '10%',
    align: 'center',
    dataIndex: 'operator',
    key: 'operator',
    scopedSlots: { customRender: 'operator' }
  },
  {
    title: '操作时间',
    width: '15%',
    align: 'center',
    key: 'created_time',
    dataIndex: 'created_time'
  },
  {
    title: '变更类型',
    width: '10%',
    align: 'center',
    key: 'operation_alias',
    dataIndex: 'operation_alias'
  },
  {
    title: '变更项',
    width: '10%',
    align: 'center',
    scopedSlots: { customRender: 'diffItem' }
  },
  {
    title: '变更前',
    align: 'center',
    width: '25%',
    scopedSlots: { customRender: 'before' }
  },
  {
    title: '变更为',
    align: 'center',
    width: '25%',
    scopedSlots: { customRender: 'after' }
  }
];
export default {
  components: { PreviewModal, UploadImg, UploadFile },
  props: {
    sourceId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      columns,
      records: [],
      userData: [],
      spinning: true,
      retrospectType,
      pagination: {
        size: 'small',
        total: 0,
        pageSize: this.$store.getters.pageSize, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      recordItems: {
        Title: { value: 'Title', label: '标题' },
        Type: { value: 'Type', label: '追溯分类' },
        Files: { value: 'Files', label: '文件' },
        Images: { value: 'Images', label: '图片' },
        StartTime: { value: 'StartTime', label: '开始时间' },
        EndTime: { value: 'EndTime', label: '结束时间' },
        ValueIsReach: { value: 'ValueIsReach', label: '是否达标' },
        RetrospectDoc: { value: 'RetrospectDoc', label: '追溯文档' },
        ConclusionDoc: { value: 'ConclusionDoc', label: '追溯小结' },
        AfterPlanDoc: { value: 'AfterPlanDoc', label: '后续计划' }
      }
    };
  },
  computed: {
    diff() {
      return data => {
        const items = [];
        const itemKeys = Object.keys(this.recordItems);
        for (const key in data) {
          if (itemKeys.includes(key)) {
            items.push({
              ...this.recordItems[key],
              ...data[key]
            });
          }
        }
        return items;
      };
    }
  },
  created() {
    if (this.sourceId !== null) this.getRecord();
    this.getUserList();
  },
  methods: {
    getUserList() {
      userList({ return_type: 'dict' }).then(res => {
        this.userData = res.data.users;
      });
    },
    getRecord() {
      queryRecords({
        source_id: this.sourceId,
        source_name: 'br_retrospect',
        page_size: this.pagination.pageSize,
        page_number: this.pagination.current
      })
        .then(res => {
          this.pagination.total = res.data.total;
          this.records = res.data.items.map((record, index) => {
            return {
              index: index + 1,
              ...record,
              value_diff: this.diff(record.value_diff)
            };
          });
          this.spinning = false;
        })
        .catch(() => {
          this.spinning = false;
        });
    },
    onPreview(content, title) {
      this.$nextTick(() => {
        this.$refs.previewModal.onOpen(content, title);
      });
    },
    handleTableChange(pagination) {
      this.pagination = pagination;
      this.getRecord();
    }
  }
};
</script>
<style lang="less" scoped>
.diff-item {
  display: block;
}

.ql-container.ql-snow {
  border: none;
}
</style>
